import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import TaskType from "./task-type";
import {isPast} from "../../system/utils";

export function useTaskType() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const getTaskTypes = async (workspaceId)=>{
        try {
            const taskType = new TaskType();
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
            }
            const _data = await taskType.getAll(query);

            return _data.data
        }catch (e){

        }
    }

    const updateTaskType = async (taskTypeId, taskTypeData)=>{
        try {
            const taskType = new TaskType();
            const _data = await taskType.update(taskTypeId, taskTypeData);
            return _data.data
        }catch (e){

        }
    }

    const createTaskType = async (taskData)=>{
        try {
            const taskType = new TaskType();
            const _data = await taskType.create(taskData);
            return _data.data
        }catch (e){

        }
    }

    return {getTaskTypes, updateTaskType, createTaskType};
}
